"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textSecondary = exports.textOverflow = exports.selectedListItem = exports.linkNoDecoration = exports.hoverListItem = exports.hoverAnimation = exports.disabled = exports.TextSecondary = exports.TextOverflow = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const textOverflow = (0, _styledComponents.css)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
exports.textOverflow = textOverflow;
const disabled = (0, _styledComponents.css)`
    opacity: 0.5 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
`;
exports.disabled = disabled;
const selectedListItem = (0, _styledComponents.css)`
    color: var(--vcs-color--primary);
    background-color: rgba(var(--vcs-color--primary-rgb), 0.1);
    box-shadow: 0 -1px 0 var(--vcs-color--primary);
    border-bottom: 1px solid var(--vcs-color--primary);
`;
exports.selectedListItem = selectedListItem;
const hoverListItem = (0, _styledComponents.css)`
    transition: all 0.25s ease-in;

    &:hover {
        cursor: pointer;
        color: var(--vcs-color--primary);
        background-color: rgba(var(--vcs-color--primary-rgb), 0.05);
    }
`;
exports.hoverListItem = hoverListItem;
const linkNoDecoration = (fontColor = 'var(--text-primary-color)') => (0, _styledComponents.css)`
    color: ${fontColor};
    text-decoration: none;

    &:hover,
    &:visited,
    &:active,
    &:focus {
        color: ${fontColor};
        text-decoration: none;
        cursor: pointer;
    }
`;
exports.linkNoDecoration = linkNoDecoration;
const hoverAnimation = (fontColor = 'var(--text-primary-color)', targetColor = 'var(--vcs-color--primary)') => (0, _styledComponents.css)`
    transition: color 0.4s ease, fill 0.4s ease;
    color: ${fontColor};
    fill: ${fontColor};

    &:hover {
        color: ${targetColor};
        fill: ${targetColor};
    }
`;
exports.hoverAnimation = hoverAnimation;
const textSecondary = (0, _styledComponents.css)`
    color: var(--text-secondary-color);
    font-size: 13px;
`;
exports.textSecondary = textSecondary;
const TextOverflow = _styledComponents.default.div`${textOverflow}`;
exports.TextOverflow = TextOverflow;
const TextSecondary = _styledComponents.default.div`${textSecondary}`;
exports.TextSecondary = TextSecondary;